// extracted by mini-css-extract-plugin
export default {"base":"Group_base__I9G8d"};